import { queryKeys } from "@/lib/data/static";
import type { QueryClient } from "@tanstack/react-query";

export type AnnotationQueryData = {
  matterId?: string;
  massTortId?: string;
};

export const getAnnotationQueryKey = (data: AnnotationQueryData) =>
  data.massTortId
    ? [queryKeys.massTorts, data.massTortId]
    : [queryKeys.matters, data.matterId];

const getMassTortId = (data: unknown) => {
  if (!data || typeof data !== "object" || !("massTortId" in data)) {
    return undefined;
  }

  const massTortId = data.massTortId;
  return typeof massTortId === "string" ? massTortId : undefined;
};

export const invalidateAnnotationQueries = async (
  queryClient: QueryClient,
  data?: unknown,
) => {
  const massTortId = getMassTortId(data);

  if (massTortId) {
    await queryClient.invalidateQueries({ queryKey: [queryKeys.massTorts] });
    return;
  }

  await queryClient.invalidateQueries({
    queryKey: [queryKeys.matters],
  });
};
